import { stores } from '@migrate/stores'
import { LocalesStore } from '@migrate/stores/LocalesStore'
import { fromIsoString, fromLocalDate, fromNative } from '@migrate/utils/date'
import { LocalDate } from '@js-joda/core'
import InstantConverter from '@migrate/utils/date/InstantConverter'

export const mmDDYYYRegEx = /^\d{1,2}[/-](\d{1,2})[/-]\d{4}$/

export default function renderDate(value?: string | LocalDate | number): string {
  const { locale } = stores[LocalesStore.STORE_NAME]

  // TODO: FIX ME WE NEED TO ENSURE DATES ARE PASSED TO THE FRONT END IN A COMMON MANOR OR
  //  CONVERTED IN THE STORES

  if (!value) {
    return ''
  }
  try {
    if (typeof value === 'number') {
      const instantConverter = new InstantConverter()
      return instantConverter.localizedFromEpochSecond(value)
    } else if (typeof value === 'string') {
      const isUSDate = mmDDYYYRegEx.test(value)
      if (isUSDate) {
        const nativeDate = new Date(value)
        return fromLocalDate(fromNative(nativeDate).toLocalDate()).toLocalizedString(locale)
      } else {
        return fromLocalDate(fromIsoString(value!).toLocalDate()).toLocalizedString(locale)
      }
    } else {
      return fromLocalDate(value as LocalDate).toLocalizedString(locale)
    }
  } catch {
    console.log('bad date', value)
    return value + ''
  }
}
